export class GPSCoordinate {
    public isGPSCoordinate:boolean = true
    private _lat: number;
    private _lng: number;
    constructor(lat:number, lng:number) {
        this._lat = lat;
        this._lng = lng;
    }
    public static parse(gpscoordstr:string):GPSCoordinate {
        if(gpscoordstr!=null&&gpscoordstr.indexOf(",")!=-1) {
            gpscoordstr = gpscoordstr.replace("gps:","");
            gpscoordstr = gpscoordstr.replace("(","");
            gpscoordstr = gpscoordstr.replace(")","");
            gpscoordstr = gpscoordstr.replace(/ /gi, "");
            let gpscoordspl = gpscoordstr.split(",");
            if(gpscoordspl.length==2) {
                let lat = parseFloat(gpscoordspl[0]);
                let lng = parseFloat(gpscoordspl[1]);
                if(!isNaN(lat)&&!isNaN(lng)) {
                    return new GPSCoordinate(lat, lng);
                }
            }
        }
        throw new Error("Could not parse as gps coordinate: '"+gpscoordstr+"'");
    }
    public toString():string {
        return "gps:"+this.lat.toFixed(6)+","+this.lng.toFixed(6);
    }
    public toFixedGPSString():string {
        return this.lat.toFixed(6)+","+this.lng.toFixed(6);
    }
    toGoogle(): any {
        return {lat: this._lat, lng: this._lng};
    }
    public static fromGoogle(googleCoord:any):GPSCoordinate {
        return new GPSCoordinate(googleCoord.lat(), googleCoord.lng());
    }
    
    public get lat():number {
        return this._lat;
    }
    public get lng():number {
        return this._lng;
    }
    public set lat(p:number) {
        this._lat = p;
    }
    public set lng(p:number) {
        this._lng = p;
    }
    public clone():GPSCoordinate {
        return new GPSCoordinate(this._lat, this._lng);
    }
    
    public distance(to:GPSCoordinate):number {
        //haversine formulae
        if ((this.lat == to.lat) && (this.lng == to.lng)) {
            return 0;
        } else {
            let radlat1 = Math.PI * this.lat/180;
            let radlat2 = Math.PI * to.lat/180;
            let theta = this.lng-to.lng;
            let radtheta = Math.PI * theta/180;
            let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
            if(dist>1) dist = 1;
            dist = Math.acos(dist);
            dist = dist * 180/Math.PI;
            dist = dist * 60 * 1.1515;
            dist = dist * 1.609344; //kilometers
            //if (unit=="N") { dist = dist * 0.8684 } //nautical miles
            return dist*1000; //to meters
        }
    }
    public lerp(toward:GPSCoordinate, distance:number):GPSCoordinate {
        this.lat+=distance * (toward.lat-this.lat);
        this.lng+=distance * (toward.lng-this.lng);
        return this;
    }
    public set(lat:number, lng:number): GPSCoordinate {
        this._lat = lat;
        this._lng = lng;
        return this;
    }
    public add(lat: number, lng: number): GPSCoordinate {
        this._lat+=lat;
        this._lng+=lng;
        return this;
    }
}